var map = {
	"./en/1/nav1_active.png": 34093,
	"./fi/1/nav1_active.png": 94727,
	"./in/1/nav1_active.png": 20465,
	"./th/1/nav1_active.png": 84992,
	"./tw/1/nav1_active.png": 96179,
	"./zh/1/nav1_active.png": 41066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74359;